export default __webpack_public_path__ + "static/media/vida-integra.f356d8dd.svg";